import PropTypes from "prop-types";
import styles from "./index.deferred.css";

const PricingRow = ({ children }) => (
  <div className={styles.row}>{children}</div>
);

PricingRow.propTypes = {
  children: PropTypes.node.isRequired
};

export default PricingRow;
